import { Box, Flex, Image } from 'dash-ui';
import styled from 'styled-components';

export const AmenityItemWrapper = styled(Flex)`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.n30};
  position: relative;
  text-align: center;

  :hover {
    & > div:last-child {
      display: flex;
    }
  }
`;

export const AmenityImage = styled(Image)`
  margin-bottom: 16px;
`;

export const ActionsWrapper = styled(Flex)`
  display: none;
  position: absolute;
  cursor: pointer;
  bottom: 5px;
  right: 5px;
`;

export const AmenityNameWrapper = styled(Box)`
  min-height: 48px;
`;
